import React__default from 'react';
import './Badge.scss';

const Badge = ({ children, className, icon, label, contentOverride, appearance = 'negative', variant = 'solid', placement = 'top right', size = 'medium', rounding = 'full', labelIconSide = 'left', }) => {
    const isIndicator = !icon && !label && !contentOverride;
    const isCircle = (icon && !label) || (!icon && label?.length === 1) || isIndicator;
    const badgeContent = (React__default.createElement("div", { "data-rev-component": 'badge', "data-rev-variant": variant, "data-rev-appearance": appearance, "data-rev-placement": placement, "data-rev-size": size, "data-rev-rounding": rounding, "data-rev-is-indicator": isIndicator, "data-rev-circle": isCircle, className: className }, contentOverride ||
        (labelIconSide === 'right' ? (React__default.createElement(React__default.Fragment, null,
            label && React__default.createElement("span", { className: 'badge-label--rev' }, label),
            icon && React__default.createElement("span", { className: 'badge-icon--rev' }, icon))) : (React__default.createElement(React__default.Fragment, null,
            icon && React__default.createElement("span", { className: 'badge-icon--rev' }, icon),
            label && React__default.createElement("span", { className: 'badge-label--rev' }, label))))));
    return children ? (React__default.createElement("div", { className: 'badge-wrapper--rev' },
        children,
        badgeContent)) : (badgeContent);
};

export { Badge };
//# sourceMappingURL=Badge.js.map
